import gql from 'graphql-tag';

export const BidPostingFields = gql`
  fragment BidPostingFields on OdProtosHomeworkData_BidPosting {
    id
    projectId
    project {
      id
      address {
        city
        state
        postalCode
      }
      unassignedLineItems {
        id
        area {
          id
          label
          value
        }
        feature {
          id
          label
          value
        }
        defect {
          id
          label
          value
        }
        latestManagerProposedLineItemScope {
          description
          laborCost {
            totalMinutes
          }
          materialCost {
            unitLabel
            quantity
          }
        }
      }
    }
    title
    description
    estimatedPriceRangeMinCents
    estimatedPriceRangeMaxCents
    bidPostingStatus
    createdAt
  }
`;
